import {deepCopyObject} from "./helper";

export function whenInvoiceTypeChange(data, invoiceTypeInfo) {

	if ((data.profileId === 'IHRACAT' && invoiceTypeInfo.profileId !== 'IHRACAT') ||
		(data.profileId !== 'IHRACAT' && invoiceTypeInfo.profileId === 'IHRACAT')) {
		let isForeignCustomer = invoiceTypeInfo.profileId === 'IHRACAT';
		data = onSwitchExtCustomer(data, isForeignCustomer);
	}

	data.profileId=invoiceTypeInfo.profileId;
	data.invoiceTypeCode=invoiceTypeInfo.invoiceTypeCode;
	if(data.profileId==="EBELGE"){
		data.documentTypeCode=invoiceTypeInfo.documentTypeCode;
	}
	data.accountingCost =invoiceTypeInfo.accountingCost;
	let trdDocInvoiceLines = data.profileId==="EBELGE" ? data.trdDocBelgeLines :data.trdDocInvoiceLines;

	for(let i=0;i<trdDocInvoiceLines.length;i++){
		if(data.profileId !== "IHRACAT") {
			trdDocInvoiceLines[i]['trdDocInvoiceLineDeliveryDetail'] = null;
		}

		if(data.profileId !== "YOLCUBERABERFATURA")
			trdDocInvoiceLines[i]['gumrukTakipNo'] = null;

		let trdDocInvoiceLineCharges = data.profileId==="EBELGE" ? trdDocInvoiceLines[i].trdDocBelgeLineCharges : trdDocInvoiceLines[i].trdDocInvoiceLineCharges;
		for(let j=0;j < trdDocInvoiceLineCharges.length;j++){
			if(data.invoiceTypeCode !== "TEVKIFAT" && data.invoiceTypeCode !== "IADE"){
				trdDocInvoiceLineCharges[j].withholdingCode = null;
				if(trdDocInvoiceLineCharges[j].taxCode==="9015"){
					trdDocInvoiceLineCharges.splice(j--,1);
				}
			}
			if(data.invoiceTypeCode === "SATIS"){
				if( trdDocInvoiceLineCharges[j].taxCode==="0015" &&
					trdDocInvoiceLineCharges[j].exemptionReasonCode!== "351"){
					trdDocInvoiceLineCharges[j].exemptionReasonCode=null;
					trdDocInvoiceLineCharges[j].exemptionReason    =null;
				}

				if( trdDocInvoiceLineCharges[j].taxCode==="0071" &&
					trdDocInvoiceLineCharges[j].exemptionReasonCode !== "151"){
					trdDocInvoiceLineCharges[j].exemptionReasonCode=null;
					trdDocInvoiceLineCharges[j].exemptionReason    =null;
				}
			}
		}
	}
	if(data.profileId==="EBELGE") {
		data['trdDocBelgeLines'] = deepCopyObject(trdDocInvoiceLines);
	}else{
		data['trdDocInvoiceLines'] = deepCopyObject(trdDocInvoiceLines);
	}

	if(data.invoiceTypeCode === "SGK"){
		let externalCustomer = {
			commerceChamber: null,
			customer: null,
			externalCustomerAddressList: [],
			familyName: null,
			formattedName: "SOSYAL GÜVENLİK KURUMU BAŞKANLIĞI",
			givenName: null,
			mersisNumber: null,
			middleName: null,
			recordId: null,
			taxOffice: "HİTİT VERGİ DAİRESİ",
			title: "SOSYAL GÜVENLİK KURUMU",
			tradeRegistrationNumber: null,
			vknTckn: "7750409379"
		};
		let externalCustomerAddress = {
			buildingName: null,
			buildingNo: null,
			cityName: "Ankara",
			citySubdivisionName: "Çankaya",
			countryName: "TÜRKİYE",
			email: null,
			fax: null,
			postalAddressRegion: null,
			postalAddressRoom: null,
			postalZone: null,
			postboxAlias: "urn:mail:defaultpk@sgk.gov.tr",
			recordId: null,
			streetName: null,
			telephone: null,
			webSite: null
		};

		externalCustomer.externalCustomerAddressList = [externalCustomerAddress];
		data.externalCustomer = externalCustomer;
		data.externalCustomerAddress = externalCustomerAddress;

		if(data.accountingCost === "DIGER")
			data.sgkFileNo = null;
	}else{
		data.accountingCost = null;
		data.sgkFileNo = null;
	}

	if(data.profileId !== "YOLCUBERABERFATURA") {
		data.trdDocInvoiceTaxFree = null;
	}

	if(data.profileId !== "IHRACAT") {
		data.paymentMeansCode = null;
		data.paymentChannelCode = null;
		data.paymentFinancialAccountId = null;
	}

	if(data.profileId !== "EARSIVFATURA" && data.profileId !== "EBELGE") {
		data.sendingType = null;
	}else{
		if(data.sendingType === null){
			data.sendingType = "ELEKTRONIK" ;
		}
	}

	if (data.invoiceTypeCode === "SARJANLIK") {
		data.esuRaporId = null;
		data.esuRaporIdIssueDate = null;
	}

	return data;
}

export function getExemptions(exemptions,type,invoiceType) {
	let results = [];
	if(invoiceType === "IADE"){
		results = exemptions.filter(exemption => exemption.exemptionType===type);
	}else{
		results = exemptions.filter(exemption => exemption.exemptionType===type &&
			exemption.invoiceType===((invoiceType==="SATIS" || invoiceType==="TEVKIFAT" || invoiceType==="SGK" ||
				invoiceType==="KOMISYONCU" || invoiceType==="HKSSATIS" || invoiceType==="HKSKOMISYONCU") ? "DIGER": invoiceType));
	}
	return results.map(result => ({
		value: result.numberCode,
		label: result.numberCode + ' - ' + result.longCode
	}));
}

export function filterOptions(options, filter, currentValues) {
	let results =  options.filter(function (option) {
		return option.value !== "Stoğa Ekle";
	});
	return results;
}

export function onSwitchExtCustomer(data , invoiceTypeInfo) {
	let isForeignCustomer = invoiceTypeInfo.profileId === 'IHRACAT';
	data.externalCustomer = {
		commerceChamber: null,
		customer: null,
		externalCustomerAddressList: [],
		familyName: null,
		formattedName: null,
		givenName: null,
		mersisNumber: null,
		middleName: null,
		recordId: null,
		taxOffice: null,
		title: null,
		tradeRegistrationNumber: null,
		vknTckn: null,
		isForeignCustomer: isForeignCustomer,
	};
	data.externalCustomerAddress = {
		buildingName: null,
		buildingNo: null,
		cityName: null,
		citySubdivisionName: null,
		countryName: null,
		email: null,
		fax: null,
		postalAddressRegion: null,
		postalAddressRoom: null,
		postalZone: null,
		postboxAlias: null,
		recordId: null,
		streetName: null,
		telephone: null,
		webSite: null
	};
	return data;
}

export function getNewInvoiceLines() {
	return [{
			recordId: null,
			itemCode: null,
			buyersItemIdentification: null,
			manufacturersItemIdentification: null,
			itemId: null,
			itemName: null,
			barcode: null,
			quantity: 1,
			unit: "C62",
			unitPrice: 1,
			lineExtensionAmount: 1,
			trdDocInvoiceLineCharges: [
				{
					recordId: null,
					taxCode: {
						recordId: 5,
						code: "0000",
						shortName: "İSKONTO",
						longName: "İSKONTO",
						direction: -1,
						calculatedBy: "AMOUNT",
						priority: -1,
						affectTaxableAmount: 1,
						mm: 0,
						smm: 0,
						inv: 1,
						isAffectKdv: 1
					},
					direction: -1,
					percentage: 0,
					exemptionReason: null,
					exemptionReasonCode: null,
					taxableAmount: 1,
					perUnitAmount: 0,
					amount: 0,
					calculatedBy: "AMOUNT",
					withholdingCode: null,
					allowanceReason: null,
				},
				{
					recordId: null,
					taxCode: {
						recordId: 1,
						code: "0015",
						shortName: "KDV GERCEK",
						longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
						direction: 1,
						calculatedBy: "AMOUNT",
						priority: 4,
						affectTaxableAmount: 0,
						mm: 0,
						smm: 1,
						inv: 1,
						isAffectKdv: 0
					},
					direction: 1,
					percentage: 20,
					exemptionReason: null,
					exemptionReasonCode: null,
					taxableAmount: 1,
					perUnitAmount: 0,
					amount: 0.20,
					calculatedBy: "AMOUNT",
					withholdingCode: null,
					allowanceReason: null,
				}
			],
			trdDocInvoiceLineDeliveryDetail: null,
		}
	];
}